// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { TurnerAddAccountParameter } from "@turnerBlueprint/App/Handlers/TurnerUpdateAccount";
import { TurnerUpdateAccountModel } from "@turnerBlueprint/App/Services/TurnerApiModels";

export async function turnerUpdateAccount(parameter: TurnerAddAccountParameter): Promise<ServiceResult<string>> {
    const accountUpdateModel: TurnerUpdateAccountModel = {
        email: parameter.email,
        firstName: parameter.accountInfo.firstName,
        lastName: parameter.accountInfo.lastName,
        companyName: parameter.accountInfo.companyName,
        jobTitle: parameter.accountInfo.jobTitle,
        phoneNumber: parameter.accountInfo.phoneNumber,
        country: parameter.accountInfo.country,
        streetAddress1: parameter.accountInfo.streetAddress1,
        streetAddress2: parameter.accountInfo.streetAddress2,
        city: parameter.accountInfo.city,
        state: parameter.accountInfo.state,
        postalCode: parameter.accountInfo.postalCode,
        uri: "",
        properties: {},
    };
    try {
        const accountModel = await post<TurnerUpdateAccountModel, string>("/api/v1/TurnerAccount", accountUpdateModel);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
